<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Dashboard
        <small>Version 2.00</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> Home
          </a>
        </li>
        <li class="active">Dashboard</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <div class="col-sm-12">
                      <div>
                        <canvas id="grap" width="400" height="100"></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import Chart from "chart.js";
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      loading: false,
      total: 0,
      type: "line",
      data: {
        labels: [
          "Mercury",
          "Venus",
          "Earth",
          "Mars",
          "Jupiter",
          "Saturn",
          "Uranus",
          "Neptune"
        ],
        datasets: [
          {
            // one line graph
            label: "Number of Moons",
            data: [5, 8, 1, 2, 67, 62, 27, 14],
            backgroundColor: [
              "rgba(54,73,93,.5)", // Blue
              "rgba(54,73,93,.5)",
              "rgba(54,73,93,.5)",
              "rgba(54,73,93,.5)",
              "rgba(54,73,93,.5)",
              "rgba(54,73,93,.5)",
              "rgba(54,73,93,.5)",
              "rgba(54,73,93,.5)"
            ],
            borderColor: [
              "#36495d",
              "#36495d",
              "#36495d",
              "#36495d",
              "#36495d",
              "#36495d",
              "#36495d",
              "#36495d"
            ],
            borderWidth: 3
          },
          {
            // another line graph
            label: "Planet Mass (x1,000 km)",
            data: [20, 12.1, 12.7, 6.7, 139.8, 116.4, 50.7, 49.2],
            backgroundColor: [
              "rgba(71, 183,132,.5)" // Green
            ],
            borderColor: ["#47b784"],
            borderWidth: 3
          }
        ]
      },
      options: {
        responsive: true,
        lineTension: 1,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25
              }
            }
          ]
        }
      }
    };
  },
  mounted(){
    // var ctx = document.getElementById('grap').getContext('2d');
    // var bar = new Chart(ctx,{
    //   type:'bar',
    //   data:this.data,
    //   options:this.options
    // })
     this.createChart();
    // console.log(2)
  },
  created() {
    // console.log(1)
  //  this.createChart();
  },
  methods: {
    createChart() {
      // console.log(this.data.datasets);
      var ctx = document.getElementById("grap").getContext("2d");
      var bar = new Chart(ctx, {
        type: "bar",
        data: this.data,
        options: this.options
      });
      // setTimeout(function(){ console.log(this.data.datasets); this.data.datasets[0].data = [20, 20,20, 2, 67, 62, 27, 14] }, 3000);
    setTimeout(this.data.datasets[0].data = [20, 20,20, 2, 67, 62, 27, 14] , 3000)
    }
  }
};
</script>